const model = {
  f: {
    name: "Фамилия",
    sex: 2,
    required: true,
    checkLength: true,
    min: 2,
    max: 32
  },
  i: {
    name: "Имя",
    sex: 1,
    required: true,
    checkLength: true,
    min: 2,
    max: 32
  },
  o: {
    name: "Отчество",
    sex: 0,
    required: false,
    checkLength: false
  },
  email: {
    name: "Email",
    sex: 1,
    required: false,
    checkLength: false,
    // eslint-disable-next-line
    regexp: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  },
  iin: {
    name: "ИИН",
    sex: 1,
    required: false,
    checkLength: false,
    isNumber: true,
    isNumberInteger: true,
    isNumberPositive: true
  },
  docs: {
    name: "Вид документа",
    sex: 1,
    required: false,
    checkLength: false
  },
  docs_number: {
    name: "Номер документа",
    sex: 1,
    required: false,
    checkLength: false,
    isNumber: true,
    isNumberInteger: true,
    isNumberPositive: true
  },
  docs_give_from: {
    name: "Кем выдан",
    sex: 0,
    required: false,
    checkLength: false
  },
  docs_give_date: {
    name: "Дата выдачи",
    sex: 2,
    required: false,
    checkLength: false,
    regexp: /\d{2}\.\d{2}\.\d{4}/
  },
  tel: {
    name: "Телефон",
    sex: 1,
    required: false,
    checkLength: false
  },
  address: {
    name: "Адрес",
    sex: 1,
    required: false,
    checkLength: false
  },
  username: {
    name: "Имя пользователя",
    sex: 0,
    required: true,
    checkLength: true,
    min: 3,
    max: 30,
    regexp: /^[a-z\d](?:[a-z\d]|[-_](?=[a-z\d])){2,30}$/i
  },
  roleId: {
    name: "Роль",
    sex: 2,
    required: true,
    checkLength: false
  },
  filialId: {
    name: "Филиал",
    sex: 1,
    required: false,
    checkLength: false
  },
  password: {
    name: "Пароль",
    sex: 1,
    required: true,
    checkLength: true,
    min: 6,
    max: 32
  },
  power_of_attorney_number_document: {
    name: "номер доверенности",
    sex: 1,
    required: false,
    checkLength: false
  },
  power_of_attorney_date_give: {
    name: "дата выдачи доверенности",
    sex: 2,
    required: false,
    checkLength: false
  }
};

module.exports = model;
